// import rxjs from 'rxjs';
import fetcher from './fetcher'
import {
    ILookupResult,
    IFundSearchRequest,
    IFundSearchResult,
    FundSearchHitKind,
} from '../types'

export function convertToSearchBarResult(apiFund: any, captionProp: string, searchTerm: string): ILookupResult {
    const label: string = apiFund[captionProp]
    const index = label.indexOf(searchTerm)
    return {
        label,
        index,
        href: `/${apiFund.url}`,
        target: '_blank',
        shortcut: '',
    }
}

export default async function fetchFundSearchResults(searchTerm: string, endpoint: string, accessToken: string) {
    const requestData: IFundSearchRequest = {
        searchString: searchTerm,
        pageSize: 15,
        page: null
    };

    const response = await fetcher<IFundSearchResult, IFundSearchRequest>(
        endpoint,
        {
            method: 'POST',
            body: requestData,
            headers: { 'Authorization': `Bearer ${accessToken}` }
        });

    const funds = response as IFundSearchResult;
    const errRes = response as { error: string};

    if (errRes.error) {
        console.info('ERROR: fetch failed:', response);
        return [];
    }

    const codeMatches = funds.funds
        ?.filter((f: any) => [FundSearchHitKind.Both, FundSearchHitKind.Code].includes(f.hitKind))
        .map(f => convertToSearchBarResult(f, 'code', searchTerm))
        .sort((a, b) => a.label < b.label ? -1 : 1)
        .sort((a, b) => (a.index||0) - (b.index||0)) || [];
    const nameMatches = funds.funds
        ?.filter((f: any) => [FundSearchHitKind.Both, FundSearchHitKind.Name].includes(f.hitKind))
        .map(f => convertToSearchBarResult(f, 'name', searchTerm))
        .sort((a, b) => a.label < b.label ? -1 : 1)
        .sort((a, b) => (a.index||0) - (b.index||0)) || [];

    return [codeMatches, nameMatches];
}
